import moment from 'moment'

export const getIsYesterday = (seconds: number) => {
  const momentRef = moment.unix(seconds)
  const yesterday = moment().subtract(1, 'days').startOf('day')

  return momentRef.isSame(yesterday, 'd')
}
